import React, { useState } from 'react';
import Navbar from '../components/Navbar/Navbar';
import Footer from '../components/Footer/Footer';
import FloatingWhatsApp from '../components/FloatingWhatsApp';
import ScrollToTop from '../components/ScrollToTop';
import SEO from '../components/SEO/SEO';

const GalleryPage = () => {
    // Categories for filtering
    const categories = ["All", "Clinic Tour", "Smile Makeovers", "Technology"];
    const [activeCategory, setActiveCategory] = useState("All");

    const galleryItems = [
        // Clinic Tour
        {
            category: "Clinic Tour",
            src: "/images/gallery-reception.png",
            title: "Modern Reception Area",
            desc: "Designed for your comfort."
        },
        {
            category: "Clinic Tour",
            src: "/images/gallery-treatment-room.png",
            title: "State-of-the-Art Treatment Room",
            desc: "Equipped with global standard technology."
        },
        {
            category: "Clinic Tour",
            src: "/images/gallery-staff-group.jpg",
            title: "Our Dedicated Team",
            desc: "Friendly professionals at your service."
        },
        {
            category: "Clinic Tour",
            src: "/images/gallery-staff-greeting.jpg",
            title: "Warm Welcome",
            desc: "Experience our unique hospitality."
        },
        {
            category: "Clinic Tour",
            src: "/images/gallery-room-green.jpg",
            title: "Modern Facilities",
            desc: "Clean and comfortable environments."
        },
        {
            category: "Clinic Tour",
            src: "/images/gallery-interior-art.jpg",
            title: "Relaxing Atmosphere",
            desc: "Designed for your peace of mind."
        },
        // Smile Makeovers
        {
            category: "Smile Makeovers",
            src: "/images/gallery-smile-1.png",
            title: "Radiant Smile",
            desc: "Confidence restored with whitening and veneers."
        },
        {
            category: "Smile Makeovers",
            src: "/images/gallery-smile-2.png",
            title: "Confident Patient",
            desc: "Complete smile restoration result."
        },
        // Technology
        {
            category: "Technology",
            src: "/images/gallery-treatment-action.jpg",
            title: "Advanced Care",
            desc: "Precision treatment in progress."
        }
    ];

    const filteredItems = activeCategory === "All"
        ? galleryItems
        : galleryItems.filter(item => item.category === activeCategory);

    return (
        <div className="bg-background-light dark:bg-background-dark text-slate-700 dark:text-slate-300 font-body transition-colors duration-300 min-h-screen">
            <SEO
                title="Gallery - Smile Transformations"
                description="View our modern dental clinic in Kottawa and browse before-and-after photos of our smile makeovers and dental treatments."
                url="/gallery-page"
            />
            <ScrollToTop />
            <Navbar />

            {/* Header Section */}
            <div className="pt-32 pb-20 bg-slate-50 dark:bg-slate-900 relative overflow-hidden">
                <div className="absolute bottom-0 right-0 -mr-20 -mb-20 w-80 h-80 bg-primary/10 rounded-full blur-3xl"></div>
                <div className="container mx-auto px-6 md:px-12 relative z-10 text-center">
                    <span className="text-secondary font-bold tracking-widest uppercase text-xs mb-3 block">
                        Visual Tour
                    </span>
                    <h1 className="font-display text-4xl lg:text-5xl font-bold text-slate-900 dark:text-white mb-6">
                        Excellence in Focus
                    </h1>
                    <div className="w-20 h-1 bg-primary mx-auto mb-8 rounded-full"></div>
                    <p className="text-lg text-slate-600 dark:text-slate-400 max-w-2xl mx-auto leading-relaxed font-light">
                        Explore our world-class facility and the life-changing results we achieve for our patents everyday.
                    </p>
                </div>
            </div>

            <section className="py-20">
                <div className="container mx-auto px-6 md:px-12">

                    {/* Filter Buttons */}
                    <div className="flex flex-wrap justify-center gap-4 mb-16">
                        {categories.map((cat) => (
                            <button
                                key={cat}
                                onClick={() => setActiveCategory(cat)}
                                className={`px-6 py-2 rounded-full text-sm font-medium transition-all duration-300 border ${activeCategory === cat
                                    ? "bg-primary text-white border-primary shadow-lg"
                                    : "bg-white dark:bg-slate-800 text-slate-600 dark:text-slate-400 border-slate-200 dark:border-slate-700 hover:border-primary hover:text-primary"
                                    }`}
                            >
                                {cat}
                            </button>
                        ))}
                    </div>

                    {/* Gallery Grid */}
                    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
                        {filteredItems.map((item, index) => (
                            <div key={index} className="group relative rounded-2xl overflow-hidden cursor-pointer shadow-sm hover:shadow-xl transition-all duration-500 bg-white dark:bg-slate-800">
                                {/* Image Container */}
                                <div className="aspect-[4/3] overflow-hidden">
                                    <img
                                        src={item.src}
                                        alt={item.title}
                                        className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-110"
                                    />
                                    {/* Overlay */}
                                    <div className="absolute inset-0 bg-gradient-to-t from-slate-900 via-slate-900/20 to-transparent opacity-0 group-hover:opacity-90 transition-opacity duration-300"></div>
                                </div>

                                {/* Content Overlay (Visible on Hover for desktop, subtle always on mobile) */}
                                <div className="absolute bottom-0 left-0 right-0 p-6 translate-y-4 group-hover:translate-y-0 transition-transform duration-300">
                                    <span className="text-primary text-xs font-bold uppercase tracking-wider mb-2 block opacity-0 group-hover:opacity-100 transition-opacity delay-100">
                                        {item.category}
                                    </span>
                                    <h3 className="text-white font-display font-bold text-xl mb-1 opacity-0 group-hover:opacity-100 transition-opacity delay-150">
                                        {item.title}
                                    </h3>
                                    <p className="text-slate-300 text-sm font-light opacity-0 group-hover:opacity-100 transition-opacity delay-200">
                                        {item.desc}
                                    </p>
                                </div>

                                {/* Always visible minimalist title (optional, good for mobile user clarity if hover is messy) */}

                            </div>
                        ))}
                    </div>

                    {filteredItems.length === 0 && (
                        <div className="text-center py-20">
                            <p className="text-slate-500">No images found in this category.</p>
                        </div>
                    )}
                </div>
            </section>

            <Footer />
            <FloatingWhatsApp />
        </div>
    );
};

export default GalleryPage;
